import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import MUIBasicsPage from './pages/MUIBasicsPage';
import ReactHookFormPage from './pages/ReactHookFormPage';
import MUIBasicsDocsPage from './pages/docs/MUIBasicsDocsPage';
import MUIThemeDocsPage from './pages/docs/MUIThemeDocsPage';
import MUILayoutDocsPage from './pages/docs/MUILayoutDocsPage';
import ReactHookFormDocsPage from './pages/docs/ReactHookFormDocsPage';
import MuiRhfAdvanced1Docs from './pages/docs/MuiRhfAdvanced1Docs';
import MuiRhfAdvanced2Docs from './pages/docs/MuiRhfAdvanced2Docs';
import MuiRhfAdvanced3Docs from './pages/docs/MuiRhfAdvanced3Docs';
import GraphqlBasics1Docs from './pages/docs/GraphqlBasics1Docs';
import GraphqlBasics2Docs from './pages/docs/GraphqlBasics2Docs';
import GraphqlBasics3Docs from './pages/docs/GraphqlBasics3Docs';
import FullIntegration1Docs from './pages/docs/FullIntegration1Docs';
import FullIntegration2Docs from './pages/docs/FullIntegration2Docs';
import FullIntegration3Docs from './pages/docs/FullIntegration3Docs';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/mui-basics" element={<MUIBasicsPage />} />
        <Route path="/react-hook-form" element={<ReactHookFormPage />} />
        <Route path="/docs/mui-basics" element={<MUIBasicsDocsPage />} />
        <Route path="/docs/mui-theme" element={<MUIThemeDocsPage />} />
        <Route path="/docs/mui-layout" element={<MUILayoutDocsPage />} />
        <Route path="/docs/react-hook-form" element={<ReactHookFormDocsPage />} />
        <Route path="/docs/mui-rhf-advanced-1" element={<MuiRhfAdvanced1Docs />} />
        <Route path="/docs/mui-rhf-advanced-2" element={<MuiRhfAdvanced2Docs />} />
        <Route path="/docs/mui-rhf-advanced-3" element={<MuiRhfAdvanced3Docs />} />
        <Route path="/docs/graphql-basics-1" element={<GraphqlBasics1Docs />} />
        <Route path="/docs/graphql-basics-2" element={<GraphqlBasics2Docs />} />
        <Route path="/docs/graphql-basics-3" element={<GraphqlBasics3Docs />} />
        <Route path="/docs/full-integration-1" element={<FullIntegration1Docs />} />
        <Route path="/docs/full-integration-2" element={<FullIntegration2Docs />} />
        <Route path="/docs/full-integration-3" element={<FullIntegration3Docs />} />
      </Routes>
    </Router>
  );
}

export default App;
